export default "__VITE_ASSET__f3810678__"